import { put, takeEvery, select } from 'redux-saga/effects'

import { includes, isNil } from 'lodash'

import { app, settings, preferences } from 'parking-react-common'

const { setLanguage, getLanguage } = preferences


//
//  SAGA

export function* saga() {
    yield takeEvery(app.INITIALIZED, setDefaultLanguage)
}

function* setDefaultLanguage() {
    const language = yield select(getLanguage)
    const browserLanguage = window.navigator.userLanguage || window.navigator.language
    if  (isNil(language)) {
        includes(settings.AVAILABLE_LANGUAGES, browserLanguage)
            ? yield put(setLanguage(browserLanguage)) : yield put(setLanguage(settings.DEFAULT_LANGUAGE))
    }
}
